import React from 'react';
import { NavLink } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const MenuNode = (props) => {

	const { linkIndex, linkTo, linkTitle, itemIcon, onClick, open, bubbleShow, titleCaption = '' } = props;

	const getClassName = ({ isActive }) => `menu-item ${isActive ? 'active' : ''}`;

	if (linkIndex) {
		return (
			<li>
				<NavLink
					to="/"
					end
					className={getClassName}
					onClick={onClick}
				>
					{(!open && !navigator.userAgent.match(/(iPad)/))
						? <OverlayTrigger
							placement="right"
							delayHide={100}
							overlay={
								<Tooltip id="sidemenu-tooltip" className="tooltip custom-tooltips">
									{linkTitle}
								</Tooltip>
							}
						>
							{itemIcon}
						</OverlayTrigger>
						: itemIcon
					}
					<div className="text">
						{linkTitle}
						{titleCaption ? <span className="title-caption">{titleCaption}</span> : ''}
					</div>
					{bubbleShow && <label className="bubble-icon"/>}
				</NavLink>
			</li>
		)
	}

	return (
		<li>
			<NavLink
				to={linkTo}
				className={getClassName}
				onClick={onClick}
			>
				{(!open && !navigator.userAgent.match(/(iPad)/))
					? <OverlayTrigger
						placement="right"
						delayHide={100}
						overlay={
							<Tooltip id="sidemenu-tooltip" className="tooltip custom-tooltips">
								{linkTitle}
							</Tooltip>
						}
					>
						{itemIcon}
					</OverlayTrigger>
					: itemIcon
				}
				<div className="text">
					{linkTitle}
					{titleCaption ? <span className="title-caption">{titleCaption}</span> : ''}
				</div>
				{bubbleShow && <label className="bubble-icon" />}
			</NavLink>
		</li>
	)
}

export default MenuNode;
